import React, { useState, useEffect } from 'react'
import {
  RaisedClaimChatBox,
  ChatHeader,
  ChatboxBody,
  TextAreaWrapper,
} from "./trackDetailTypeOneStyled";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import ChatUserIcon from 'web/assets/svg/ChatUserIcon';
import { postClaimMessage, updateReceivedClaimMessage } from 'redux/actions/myClaims';
import ChatCloseIcon from 'web/assets/svg/ChatCloseIcon'
import ChatEnterIcon from "web/assets/svg/ChatEnterIcon";
const ChatboxComponent = ({ item, toggleFunction, chatMessageListValue }) => {

  const dispatch = useDispatch();
  let history = useHistory();

  const [raiseClaimtoggle, setraiseClaimtoggle] = useState(true)
  const [chatMessageList, setchatMessageList] = useState(chatMessageListValue)
  const [chatMessage, setChatMessage] = useState("")
  const [chatCount, setChatCount] = useState(0)

  useEffect(() => {
    const intervalCall = setInterval(() => {

      fetchApiForChatMessage()

    }, 2000);
    return () => clearInterval(intervalCall)
  }
    , [])


  const fetchApiForChatMessage = async () => {

    const token = localStorage.getItem('token');
    let locationId = localStorage.getItem("locationID")
    let buyerLocationId, sellerLocationID
    if (item.order?.buyerInfo?.locationsId) {
      let buyerLocationIdTemp = item.order?.buyerInfo?.locationsId?.filter(val => val == locationId)
      if (buyerLocationIdTemp?.length > 0) buyerLocationId = item.order?.buyerInfo?.locationsId?.toString()
    }
    else {
      if (item.order?.buyerInfo?.locationId === locationId) buyerLocationId = item.order?.buyerInfo?.locationId
    }

    if (item.order?.sellerInfo?.locationsId) {
      let sellerLocationIdTemp = item.order?.sellerInfo?.locationsId?.filter(val => val == locationId)
      if (sellerLocationIdTemp?.length > 0) sellerLocationID = item.order?.sellerInfo?.locationsId?.toString()
    }
    else {
      if (item.order?.sellerInfo?.locationId === locationId) sellerLocationID = item.order?.sellerInfo?.locationId
    }

    let data = {
      userAuth: buyerLocationId ? buyerLocationId : sellerLocationID ? sellerLocationID : '',
      userType: buyerLocationId ? 'BUYER' : sellerLocationID ? 'SELLER' : '',
      orderId: item.orderId,
      admin: "demo",
      claimId: item.id,
      date: new Date(),
      msg: chatMessage,
      from: buyerLocationId ? 'BUYER' : sellerLocationID ? 'SELLER' : '',
      to: "ADMIN"
    }

    let response = await dispatch(postClaimMessage(data, token));

    if (response && response.status === 'SUCCESS') {
      setchatMessageList(response?.payload?.msg)
      setChatCount(response?.payload?.unreadMsgCount)
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      }
    }

  }

  const updatefetchApiForChatMessage = async (item) => {
    setChatCount(0)
    const token = localStorage.getItem('token');

    let locationId = localStorage.getItem("locationID")
    let buyerLocationId, sellerLocationID
    if (item.order?.buyerInfo?.locationsId) {
      let buyerLocationIdTemp = item.order?.buyerInfo?.locationsId?.filter(val => val == locationId)
      if (buyerLocationIdTemp?.length > 0) buyerLocationId = item.order?.buyerInfo?.locationsId?.toString()
    }
    else {
      if (item.order?.buyerInfo?.locationId === locationId) buyerLocationId = item.order?.buyerInfo?.locationId
    }

    if (item.order?.sellerInfo?.locationsId) {
      let sellerLocationIdTemp = item.order?.sellerInfo?.locationsId?.filter(val => val == locationId)
      if (sellerLocationIdTemp?.length > 0) sellerLocationID = item.order?.sellerInfo?.locationsId?.toString()
    }
    else {
      if (item.order?.sellerInfo?.locationId === locationId) sellerLocationID = item.order?.sellerInfo?.locationId
    }

    let data = {
      userAuth: buyerLocationId ? buyerLocationId : sellerLocationID ? sellerLocationID : '',
      userType: buyerLocationId ? 'BUYER' : sellerLocationID ? 'SELLER' : '',
      claimId: item.id,
      orderId: item.orderId,
      admin: "demo"
    }

    let response = await dispatch(updateReceivedClaimMessage(data, token));

    if (response && response.status === 'SUCCESS') {
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      }
    }
  }

  const postMessage = async () => {
    if (chatMessage.length) {

      const token = localStorage.getItem('token');
      const locationId = localStorage.getItem("locationID")

      let buyerLocationId, sellerLocationID

      if (item.order?.buyerInfo?.locationsId) {
        let buyerLocationIdTemp = item.order?.buyerInfo?.locationsId?.filter(val => val == locationId)
        if (buyerLocationIdTemp?.length > 0) buyerLocationId = item.order?.buyerInfo?.locationsId?.toString()
      }
      else {
        if (item.order?.buyerInfo?.locationId === locationId) buyerLocationId = item.order?.buyerInfo?.locationId
      }

      if (item.order?.sellerInfo?.locationsId) {
        let sellerLocationIdTemp = item.order?.sellerInfo?.locationsId?.filter(val => val == locationId)
        if (sellerLocationIdTemp?.length > 0) sellerLocationID = item.order?.sellerInfo?.locationsId?.toString()
      }
      else {
        if (item.order?.sellerInfo?.locationId === locationId) sellerLocationID = item.order?.sellerInfo?.locationId
      }

      let data = {
        userAuth: buyerLocationId ? buyerLocationId : sellerLocationID ? sellerLocationID : '',
        userType: buyerLocationId ? 'BUYER' : sellerLocationID ? 'SELLER' : '',
        orderId: item.orderId,
        admin: "demo",
        claimId: item.id,
        date: new Date(),
        msg: chatMessage,
        from: buyerLocationId ? 'BUYER' : sellerLocationID ? 'SELLER' : '',
        to: "ADMIN"
      }
      setChatMessage("")
      let response = await dispatch(postClaimMessage(data, token));


      if (response && response.status === 'SUCCESS') {

        setchatMessageList(response?.payload?.msg)

      } else {

        if (response.statusCode === 401) {
          history.push('/sign-in')
          window.location.reload(false);
        }
      }
    }
  }



  return (

    <>

      <div style={{ marginRight: "" }}>


        {raiseClaimtoggle &&
          <RaisedClaimChatBox style={{ right: "20px" }}>
            <ChatHeader style={{ maxHeight: "15%", maxWidth: "", marginLeft: "" }}>
              <ChatUserIcon color="#fff" />
              <h6>
                Chat with Admin
              </h6>
              <ChatCloseIcon
                className="close-icon"
                onClick={() => {
                  setraiseClaimtoggle(false)
                  updatefetchApiForChatMessage(item)
                  toggleFunction("")

                }}

              />
            </ChatHeader>
            <div style={{ height: "200px", overflow: "auto", display: 'flex', flexDirection: 'column-reverse' }}>
              <div>
                <ChatboxBody style={{ backgroundColor: '' }}>
                  <div style={{ position: 'sticky', top: '0px', textAlign: 'center', zIndex: '2', margin: '5px' }}>

                  </div>

                  {chatMessageList && chatMessageList.map(data => {
                    return (
                      <>
                        {data.msg.length > 0 &&
                          <div className={data.from != 'ADMIN' ? 'chat-listing-user' : 'chat-listing-admin'}>
                            {data.from == "BUYER" &&
                              <ChatUserIcon color="#0a5587" />
                            }
                            {data.from == "SELLER" &&
                              <ChatUserIcon color="#69BBE0" />
                            }
                            {data.from == "ADMIN" &&
                              <ChatUserIcon color="#6d7b69" />
                            }

                            <div style={{ overflow: "hidden" }}>
                              {data.from == "BUYER" &&
                                <p class="chat-container" style={{ backgroundColor: "#0a5587" }}>{data.msg}</p>
                              }
                              {data.from == "SELLER" &&
                                <p class="chat-container">{data.msg}</p>
                              }
                              {data.from != "SELLER" && data.from != "BUYER" &&
                                <p class="chat-container darker">{data.msg}</p>
                              }

                              <span class={data.from != 'ADMIN' ? "time-right" : "time-left"}>
                                {moment(data.date).format('MMM Do, YYYY, HH:mm')}
                              </span>
                            </div>
                          </div>
                        }
                      </>
                    )
                  })}

                </ChatboxBody>
              </div>
            </div>
            <TextAreaWrapper>
              <textarea
                style={{ width: "100%" }}
                value={chatMessage}
                rows="1"
                placeholder="Please Type Message"
                onChange={(e) => {
                  setChatMessage(e.target.value)
                }
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    postMessage()
                  }
                }}

              />
              <ChatEnterIcon
                style={{ opacity: chatMessage !== '' ? '1' : '0.5' }}
                onClick={() =>
                  postMessage()
                }

              />
            </TextAreaWrapper>
          </RaisedClaimChatBox>
        }

      </div>
    </>
  )
}

export default ChatboxComponent